if (!customElements.get('collection-continuation')) {
  class TG_CollectionContinuation extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      var _this = this;

      this.carousels = [];

      themegoal.helpers.Dom.nodeListToArray(this.querySelectorAll('[data-carousel-config]')).forEach(function (item) {
        _this.carousels.push(new themegoal.components.Carousel(item));
      });
    }

    disconnectedCallback() {
      if (this.carousels) {
        this.carousels.forEach(function (carousel) {
          carousel.destroy();
        });
      }
    }
  }

  customElements.define('collection-continuation', TG_CollectionContinuation);
}
